import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import loader from "../assets/loader.json";
import { DataGrid } from "@mui/x-data-grid";
import { useDeleteSubadminMutation, useGetSubadminListQuery } from "../redux/features/user/userApi";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Navbar from "../Components/Navbar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Subadmin = () => {
  // Restrict access for subadmin users
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  React.useEffect(() => {
    if (role !== "admin") {
      navigate("/unauthorized");
    }
  }, [role, navigate]);

  const [rows, setRows] = useState([]);
  const { data, isSuccess, isError, isLoading, refetch } = useGetSubadminListQuery();
  const [deleteSubadmin, { isSuccess: deleteSuccess, data: deleteData, isError: deleteError }] = useDeleteSubadminMutation();

  useEffect(() => {
    if (isSuccess && data?.data) {
      const formattedRows = data.data.map((item, index) => {
        const options = {
          year: "numeric",
          month: "long",
          day: "numeric",
        };

        const date = new Date(item.created_at).toLocaleDateString("en-US", options);
        const active = item.isActive ? "Active" : "Deactive";

        return {
          id: index + 1,
          userId: item._id,
          email: item.email,
          name: item.username,
          created_at: date,
          status: active,
        };
      });
      setRows(formattedRows);
    }
  }, [isSuccess, data]);

  useEffect(() => {
    if (deleteSuccess && deleteData?.status === true) {
      toast.success(deleteData.message);
      refetch(); // Refresh the list after successful deletion
    } else if (deleteError) {
      toast.error("Failed to delete subadmin");
    }
  }, [deleteSuccess, deleteData, deleteError, refetch]);

  const handleDelete = async (id) => {
    try {
      await deleteSubadmin(id);
    } catch (error) {
      toast.error("Failed to delete subadmin");
    }
  };

  const columns = [
    { field: "id", headerName: "S.No", flex: 0.25, minWidth: 100 },
    { field: "email", headerName: "Email", flex: 1, minWidth: 250 },
    { field: "name", headerName: "User Name", flex: 0.5, minWidth: 150 },
    { field: "created_at", headerName: "Created On", flex: 0.75, minWidth: 200 },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      minWidth: 150,
      renderCell: (params) => {
        const statusClass = params.value === "Active" ? "text-green-500" : "text-yellow-500";
        return <span className={statusClass}>{params.value}</span>;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.25,
      minWidth: 100,
      renderCell: (params) => (
        <button onClick={() => navigate(`/subadmin/${params.row.userId}`)}>
          <FaEdit className="text-black" size={20} />
        </button>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 0.25,
      minWidth: 100,
      renderCell: (params) => (
        <button onClick={() => handleDelete(params.row.userId)}>
          <MdDelete className="text-red-500" size={20} />
        </button>
      ),
    },
  ];

  const style = {
    height: 100,
    width: 100,
    margin: "auto",
    alignItem: "center",
  };

  if (isLoading) {
    return <Lottie animationData={loader} style={style} loop={true} width={20} />;
  }

  return (
    <>
      <Navbar />
      <div className="w-[80vw] mx-auto h-full">
        <div className="w-full mt-[10px] border">
          <div className="flex justify-between p-5 text-blue-900 font-bold">
            <h1 className="text-2xl">Subadmin Details</h1>
            <button className="border-2 rounded-lg p-2" onClick={() => navigate("add-new")}>
              + Add New
            </button>
          </div>
          <DataGrid 
            columns={columns} 
            rows={rows} 
            pageSize={25}
            rowsPerPageOptions={[25]}
            disableSelectionOnClick
          />
        </div>
      </div>
    </>
  );
};

export default Subadmin;
